import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService as toastService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class ToastrService {

  constructor(public toastr: toastService, public router: Router) { }
  
  success(message, title?) {
    this.toastr.success(message)
  } 

  info(message, title?) {
    this.toastr.info(message)
  }

  error(message, title?) {
    this.toastr.error(message)
  }

  warning(message, title?) {
    this.toastr.warning(message)
  }

  successReport(message, title?) {
    this.toastr.success(message, null,{
      tapToDismiss: false,
      onActivateTick: true,
    }).onTap.subscribe(() => {
      this.router.navigate(['/home/informes/descargas'])
    })
  } 
}
